import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AccessionSearchResult } from './../register-sample-info';
@Component({
    selector: 'sample-details',
    template: require('./sample-details.component.html'),
    styles: [require('./sample-details.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleDetailsComponent {

    @Input()
    public accessionData: AccessionSearchResult;
    @Input()
    public accessionDetails: any;

    constructor() {

    }
}
